import { render, staticRenderFns } from "./Klubi.vue?vue&type=template&id=59749192&"
import script from "./Klubi.js?vue&type=script&lang=js&"
export * from "./Klubi.js?vue&type=script&lang=js&"
import style0 from "./Klubi.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
